import { useAppSelector } from 'hooks/reduxHooks'
import { useMemo } from 'react'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { useScreenSizeOnly } from 'hooks/useScreenSize'

export function getAccommodationMapSearchPath(pathname: string): string {
  return pathname.includes('/homes-and-villas') ? '/search/homes-and-villas/map' : '/search/map'
}

function useAccommodationMapSearchPath(): string {
  const pathname = useAppSelector(state => state.router.location.pathname)
  const isMobileScreen = useScreenSizeOnly('mobile')
  const isSplitMapEnabled = !!useOptimizelyExperiment(OptimizelyExperiments.searchSplitMapView, isMobileScreen)

  return useMemo(() => {
    if (!pathname.includes('/homes-and-villas') && isMobileScreen && isSplitMapEnabled) return '/search/map-split'
    return getAccommodationMapSearchPath(pathname)
  }, [pathname, isMobileScreen, isSplitMapEnabled])
}

export default useAccommodationMapSearchPath
